import { useInit } from 'reactApp/ui/App/effect/useInit';

export const InitComponent = ({ setIsLoading }) => {
    useInit({ setIsLoading });

    return null;
};
